import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { checkboxClasses } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import RefreshIcon from "@mui/icons-material/Refresh";
import { STATIC_STRINGS } from "../../../../../utils/Constants";
import { useState } from "react";

const RenderData = ({ questions }: { questions: any }) => {
  const [currentQuestion, setCurrentQuestion] = useState<number>(0);
  const [askUnique, setAskUnique] = useState<boolean>(false);
  const totalQuestions = questions.totalQuestions;

  return (
    <div className="w-full h-2/3 text-sm xl:text-base">
      <div className="flex flex-col h-full">
        <div className="w-full flex justify-between items-center">
          <button
            className={`btn ${
              currentQuestion === 0 ? `btn-outline-disabled` : `btn-primary`
            } mr-1`}
            onClick={() => {
              setCurrentQuestion((p) => (p > 0 ? p - 1 : 0));
            }}
            disabled={currentQuestion === 0}
          >
            <ChevronLeftIcon />
            {STATIC_STRINGS.PREVIOUS_QUESTION}
          </button>

          <div className="text-center font-medium">
            <div>{STATIC_STRINGS.QUESTIONS_PREVIEW}</div>
            <div className="text-xl font-bold">
              {currentQuestion + 1} of {totalQuestions}
            </div>
          </div>

          <button
            className={`btn ${
              currentQuestion === totalQuestions - 1
                ? `btn-outline-disabled`
                : `btn-primary`
            }`}
            onClick={() => {
              setCurrentQuestion((p) => (p < totalQuestions - 1 ? p + 1 : p));
            }}
            disabled={currentQuestion === totalQuestions - 1}
          >
            {STATIC_STRINGS.NEXT_QUESTION} <ChevronRightIcon />
          </button>
        </div>
        <div className="w-full flex flex-wrap gap-1 justify-start items-center p-2">
          <div className="custom-box">
            {`${STATIC_STRINGS.TOPIC} : ${questions.allQuestions[currentQuestion].topic}`}
          </div>
          <div className="custom-box">
            {`${STATIC_STRINGS.TOPIC} : ${questions.allQuestions[currentQuestion].subtopic}`}
          </div>
          <div className="custom-box">{`${
            STATIC_STRINGS.QUESTION_TYPE
          } : ${questions.allQuestions[
            currentQuestion
          ].questionType.toLowerCase()}`}</div>
          <div className="custom-box">
            {`${STATIC_STRINGS.DIFFICULTY_LEVEL} : ${questions.allQuestions[
              currentQuestion
            ].difficulty.toLowerCase()}`}
          </div>
          <div className="custom-box">{`${STATIC_STRINGS.SCORE} : ${questions.allQuestions[currentQuestion].maxScore}`}</div>
          <div className="custom-box">
            {`${STATIC_STRINGS.ESTIMATED_TIME} : ${
              questions.allQuestions[currentQuestion]
                .expectedTimeToSolveForStudentInSeconds / 60
            } Min`}
          </div>
        </div>
        <div className="w-full text-base xl:text-lg bg-secondary rounded-lg h-full p-1">
          <div className="p-1 font-medium">
            {questions.allQuestions[currentQuestion].questionStatement}
          </div>
          {questions.allQuestions[currentQuestion].questionType ===
            STATIC_STRINGS.MCQ && (
            <div className="p-1">
              {questions.allQuestions[currentQuestion].options.map((option) => (
                <div className="w-full p-2 border-[1px] border-neutral-dark mb-2 rounded-md">
                  {option.optionStatement}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="flex w-full justify-between items-center">
          <FormControlLabel
            value="end"
            control={
              <Checkbox
                checked={askUnique}
                onChange={(e) => setAskUnique(e.target.checked)}
                sx={{
                  [`&, &.${checkboxClasses.checked}`]: {
                    color: "var(--color-neutral-dark)",
                  },
                }}
              />
            }
            label="Ask Unique Question From Everyone"
            labelPlacement="start"
            slotProps={{
              typography: {
                sx: { fontWeight: "bold" },
                fontSize: {
                  md: "0.875rem",
                  lg: "1rem",
                },
              },
            }}
          />
          <button onClick={() => {}} className="btn btn-outline m-1">
            <RefreshIcon /> {STATIC_STRINGS.REGENERATE_QUESTION}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenderData;
